import React from "react";
const helpcanvas = {
  display: 'grid',
  gridTemplateColumns: '2fr 3fr 5fr',
  gridTemplateRows: 'min-content 1fr',
  backgroundColor: "#f2f2f2",
  height: '100vh',
  width: '100%',
  rowGap: '24px',
  columnGap: '14px',
  padding: '0 0 14px 0',
};

const helptitle = {
  color: "#222",
  backgroundColor: "#f2f2f2",
  padding: "2px",
  fontFamily: "Arial",
  fontSize: "13px",
};

const helpimg = {
    color: "#222",
    backgroundColor: "#f2f2f2",
    padding: "2px",
    fontFamily: "Arial",
  };

const UIADUsers = {
    name: 'Add User Screen',
    imageUrl: '../../images/ADUsers.png',
    imageSize: "90%",
    bradius: 20,
  };

const UIADUserform = {
    name: 'User Form',
    imageUrl: '../../images/ADUserform.png',
    imageSize: "99%",
    bradius: 20,
  };

const UIADUserexist = {
    name: 'User Form',
    imageUrl: '../../images/ADUserexist.png',
    imageSize: "99%",
    bradius: 20,
  };

const UIADDepts = {
    name: 'User Form',
    imageUrl: '../../images/ADDepts.png',
    imageSize: "99%",
    bradius: 20,
  };

const UIADCustomdepts = {
    name: 'User Form',
    imageUrl: '../../images/ADCustomdepts.png',
    imageSize: "99%",
    bradius: 20,
  };



export const ADUsers = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Add or Update Users </b><br/><br/>
      Update existing users or add new users on the User Management page.  <br/><br/>
      To update an existing user, use the dropdown selector to find a user, and once selected, hit "Submit" <br/><br/>
      To add a new user, click on Add New User.  
      </div>
      <div style={helpimg}>
      <img
        src={UIADUsers.imageUrl}
        alt={'Image of ' + UIADUsers.name}
        style={{
          width: UIADUsers.imageSize,
          borderRadius: UIADUsers.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const ADUserform = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>User Management Form</b><br/><br/>
      Adding or Modifying a user makes use of the same form. The form is prefilled when modifying a 
      user, or blank when adding a user. <br/><br/>
      The bottom of the form includes a button to "View Encryption Passwords" when modifying an 
      existing user. When users select File Encryption as a mitigation method when performing file 
      mitigation, the password that was entered to perform the encrypt operation is recoverable here. 
      This allows password recovery in the event that a user leaves the organization and the encrypted 
      file passwords are unknown. This feature is ONLY available to users with the Administrator role, 
      and the administrator password must be re-entered before passwords are made visible. 
      </div>
      <div style={helpimg}>
      <img
        src={UIADUserform.imageUrl}
        alt={'Image of ' + UIADUserform.name}
        style={{
          width: UIADUserform.imageSize,
          borderRadius: UIADUserform.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const ADUserexist = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Existing Users</b><br/><br/>
      The bottom section of the page shows a list of existing users. Use the search field to narrow the list of users. 
      Use the edit button to update or modify a specific user.
      </div>
      <div style={helpimg}>
      <img
        src={UIADUserexist.imageUrl}
        alt={'Image of ' + UIADUserexist.name}
        style={{
          width: UIADUserexist.imageSize,
          borderRadius: UIADUserexist.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const ADDepts = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Built-in Departments</b><br/><br/>
      Manage Organizational Departments <br/><br/>
      Departments are internal divisions within an organization. In CYRISMA, the purpose of 
      departments is to organize Risk Mitigation efforts. Departments segment an organization 
      into areas of responsibility where users are assigned a department depending on their 
      role within the organization. There are several common departments that are built in, 
      plus the ability to add any departments that may be needed. When mitigation plans or 
      sub-plans are assigned to individuals, plans are typically handled by department, and 
      sub-plans are assigned to people within the same department. <br/><br/>
      Built-in Departments <br/><br/>
      In the top section of the department management page, built-in departments are listed. 
      These departments’ names are for convenience and cannot be deleted or edited. Many 
      organizations work within the existing departments listed here and many others manage 
      departments by creating a list of their own. 
      </div>
      <div style={helpimg}>
      <img
        src={UIADDepts.imageUrl}
        alt={'Image of ' + UIADDepts.name}
        style={{
          width: UIADDepts.imageSize,
          borderRadius: UIADDepts.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const ADCustomdepts = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Custom Departments</b><br/><br/>
      If Custom Departments are to be used, it is recommended to set up these department names 
      and descriptions BEFORE adding users. However, a department can be added at any time, 
      and existing users can be moved as long as they are not participating in an open mitigation 
      sub-plan. <br/><br/>
      To add a new department, click "Add New" and enter the name and description of the 
      department in the form fields that appear. Save or cancel the action as required. <br/><br/>
      Custom departments can be enabled or disabled. Disabled departments do not show up when setting 
      up mitigation plans.
      </div>
      <div style={helpimg}>
      <img
        src={UIADCustomdepts.imageUrl}
        alt={'Image of ' + UIADCustomdepts.name}
        style={{
          width: UIADCustomdepts.imageSize,
          borderRadius: UIADCustomdepts.bradius,
        }}
      />
      </div>
    </div>
  );
};
